import {fetchTrackOddsClick, fetchTrackChannelClick} from "../api/general"

// Send simple Async API call
export const asyncOddsClickTracker = (
  widgetId: number,
  providerId: number,
  outLink: string,
  competitionId: number|null = null,
): void => {
  fetchTrackOddsClick({
    widgetId: widgetId,
    provider_id: providerId,
    page: window.location.href,
    link: outLink,
    competition_id: competitionId,
  }).then(() => {
    console.log('Widget: Success odds track.')
  }).catch(() => {
    console.error('Widget Error: Fail odds track.')
  })
}

export const asyncChannelClickTracker = (
  widgetId: number,
  channelId: number,
  outLink: string,
  competitionId: number|null = null,
): void => {
  fetchTrackChannelClick({
    widgetId: widgetId,
    channel_id: channelId,
    page: window.location.href,
    link: outLink,
    competition_id: competitionId,
  }).then(() => {
    console.log('Widget: Success channel track.')
  }).catch(() => {
    console.error('Widget Error: Fail channel track.')
  })
}